import { notification } from 'antd';
import { saveAs } from 'file-saver';
import request from './request';

// 验证是否为blob格式
export const blobValidate = (data) => {
  return data.type && (data.type.indexOf('application/json') === -1);
}

export const download = async (url, params, filename) => {
  try {
    console.log("url:", url, "params:", params, "filename:", filename);

    const response = await request({
      url: url,
      method: 'POST',
      data: params,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json'
      },
    });

    const isBlob = blobValidate(response);
    if (isBlob) {
      const blob = new Blob([response]);
      saveAs(blob, filename);
      notification.success({
        message: 'Export successful',
        description: `File ${filename} exported`,
      });
    } else {
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = e.target.result;
        const result = JSON.parse(text);
        notification.error({
          message: 'Export failed',
          description: result.message || 'Unknown error',
        });
      };
      reader.readAsText(response);
    }
  } catch (error) {
    notification.error({
      message: 'Export failed',
      description: 'An error occurred while downloading the file. Please contact the administrator!',
    });
    console.error('Download error:', error);
  }
};
